<template>
  <div>
    <callout
      :has-toggle="canReject"
      :opened="isOpened"
      :controlled="true"
      class="mb-3 mt-1 bg-callout"
      @click:open="handleCallout()"
    >
      <div class="row mt-2 pb-4 evaluetions-card">
        <div class="col-md-2 col-sm-12 border-right-2 bottom-space">
          <div v-if="isMobile" class="row bottom-reductor">
            <div class="col-7">
              <div class="font-weight-normal font-14 color-gray--6">
                {{ itemsEval.evaluationType }}
              </div>
            </div>
            <div class="col-5">
              <div v-if="!isSubmitted" class="col-md-1 col-sm-5 text-right">
                <a class="drop-item" href="#" @click="$emit('on-delete')">
                  <i
                    class="fas fa-times-circle text-red font-25 mt-3 icon-align"
                  />
                </a>
              </div>
            </div>
          </div>
          <div
            v-if="!isMobile"
            class="font-weight-normal font-14 color-gray--6"
          >
            {{ itemsEval.evaluationType }}
          </div>
          <span class="font-weight-normal font-16 color-black--2">
            <strong>{{ itemsEval.disciplineTypeName }}</strong>
          </span>

          <hr class="divider-horizontal" />
        </div>

        <div class="col-md-2 col-sm-12" style="padding-bottom: 10px">
          <div class="font-weight-normal font-14 color-gray--6">
            Estatus de Evaluación:
          </div>
          <span class="font-weight-normal font-16 color-black--2">
            <strong>{{ itemsEval.statusName }}</strong>
          </span>
          <br />
        </div>

        <div class="col-md-2 col-sm-12" style="padding-bottom: 10px">
          <div class="font-weight-normal font-14 color-gray--6">
            Fecha de Evaluación:
          </div>
          <span class="font-weight-normal font-16 color-black--2">
            <strong>{{ itemsEval.evaluationDate | date | empty }}</strong>
          </span>
        </div>
        <div class="col-md-3 col-sm-12">
          <div class="font-weight-normal font-14 color-gray--6">
            Estatus de la Discusión:
          </div>
          <span class="font-weight-normal font-16 color-black--2">
            <ValidationProvider v-slot="{ errors }" rules="required">
              <custom-drop-down
                v-model="model.discussionStatus"
                :disabled="
                  ((itemsEval.discussionStatusId != null ||
                    itemsEval.discussionStatusId != DiscussionStatus.Pending) &&
                    !itemsEval.editable) ||
                    isSubmitted
                "
                :clearable="!isSubmitted"
                placeholder="Seleccione"
                required="required"
                fieldkey="id"
                fieldname="name"
                :options="
                  discussionStatuses.filter(
                    (x) =>
                      x.id != DiscussionStatus.Pending &&
                      x.id != DiscussionStatus.NA
                  )
                "
                :error="errors[0]"
                custom-error-msg="El estatus de la discusión es requerido."
                @input="(val) => onChangeDiscussionStatus(val)"
              />
            </ValidationProvider>
          </span>
        </div>
        <div
          v-if="isDiscussionAccepted && !isOcupacional"
          class="col-md col-sm-12"
        >
          <div style="height: 110px" class="row justify-content-end">
            <div class="col-12">
              <span class="font-weight-normal font-14 color-gray--6">
                ¿Esta evaluación será utilizada en una determinación de
                elegibilidad?
              </span>
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-radio
                  v-model="model.isImpedimentEvaluationFlag"
                  :change-event="(item) => onChangeYesNo(item)"
                  class="custom-radio__extended p-0 m-0"
                  container-class="custom-radio-center"
                  custom-error-msg="Marque si o no."
                  :error="Boolean(errors[0])"
                  is-question-list
                  label="test"
                  name="determineOption"
                  :options="yesNoOptions"
                  :disabled="isSubmitted || determinationDisabled"
                />
              </validation-provider>
            </div>
          </div>
        </div>
        <div class="col-md-2 col-sm-12 download-document__container">
          <ActionButton
            v-if="showDownloadDocument"
            variant="outline-success"
            i="fas fa-file-download"
            @click="downloadDocument(itemsEval.studentEvaluationId)"
          >
            Descargar
          </ActionButton>
        </div>
        <div v-if="!isMobile && !isSubmitted" class="btn-remove-evluation">
          <ActionButton
            variant="drop-item"
            i="fas fa-times-circle text-red font-25 mt-3 icon-align"
            @click="$emit('on-delete')"
          />
        </div>
      </div>
      <div
        v-if="isPartialAccepted"
        class="alert__container alert alert-warning"
        role="alert"
      >
        <div class="alert-content">
          <i class="fas mr-2 fa-bell-exclamation" />
          <span>
            Un rechazo a las partes Datos de identificación, Métodos evaluativo
            o Pruebas administradas conlleva a que las demás áreas de las
            evaluaciones queden invalidadas. Por tanto, se recomienda que la
            evaluación sea rechazada en su totalidad.
          </span>
        </div>
      </div>
      <div v-if="itemsEval.reevaluationRequired" class="row mt-3">
        <div class="col-md-12 col-sm-12">
          <div class="ml-1 pt-3 mr-4">
            <div>
              <div class="font-weight-normal font-16 color-gray--6">
                <span>
                  <i class="fas fa-info-circle text-orange font-25" />
                </span>
                Requiere reevaluación a partir de la implementación de
                recomendaciones ofrecidas en este informe de evaluación:
                <br />
                <b class="color-black">
                  {{ itemsEval.reevaluationTime }}
                  {{ itemsEval.reevaluationPeriod }}
                </b>
              </div>

              <p>
                <b>Comentario: {{ itemsEval.reevaluationPurpose }}</b>
              </p>
            </div>
          </div>
        </div>
      </div>
      <template #edition>
        <div class="px-0 py-1">
          <div class="bg-white rounded px-3 py-1 my-3 mx-4">
            <div class="row pt-3 mr-4">
              <div class="pl-3">
                <i class="fas fa-info-circle text-orange" />
              </div>
              <div class="col-md-10 col-sm-10">
                <b>{{ rejectionLabel }}</b>
              </div>
            </div>
            <validation-observer ref="evaluationToRejectForm">
              <div v-if="!isSubmitted" class="row">
                <div class="col-md-5 col-sm-12 mt-2 pb-4">
                  <span class="font-weight-normal font-14 color-gray--6">
                    {{ rejectionReasonLabel }}
                  </span>
                  <div class="d-flex">
                    <CustomDropDown
                      v-model="model.rejectionReason"
                      placeholder="Seleccione"
                      required="required"
                      fieldkey="id"
                      fieldname="name"
                      :options="computedRejectionReasonsList"
                      :disabled="isSubmitted"
                      class="w-100"
                    />
                    <ActionButton
                      v-if="!isSubmitted"
                      type="submit"
                      variant="success"
                      class="px-1 actions mb-2"
                      i="fas fa-plus px-2"
                      @click.native.prevent="addSelectedRejectedReason"
                    ></ActionButton>
                  </div>
                  <div>
                    <CustomChipsGroup
                      title=""
                      object-text="name"
                      :selected-items="preSelectedRejectionReasons"
                      :on-item-deleted="removeSelectedRejectedReason"
                      no-background
                      no-wrap
                    />
                  </div>
                </div>
                <div class="col-md-7 col-sm-12 mt-2 pb-4">
                  <span class="font-weight-normal font-14 color-gray--6">
                    {{ rejectionCommentLabel }}:
                  </span>
                  <validation-provider
                    v-slot="{ errors }"
                    mode="eager"
                    :rules="
                      `${preSelectedRejectionReasons.length ? 'required' : ''}`
                    "
                  >
                    <CustomTextArea
                      v-show="true"
                      id="rejectionComment"
                      v-model="model.rejectionComment"
                      placeholder="Escribe un comentario"
                      :maxlength="3000"
                      :classes="['eq-field', 'text-right']"
                      :rows="0"
                      :error="errors[0]"
                      custom-error-msg="El comentario es requerido."
                      :disabled="isSubmitted"
                    />
                  </validation-provider>
                </div>
              </div>
              <div
                v-if="!isSubmitted"
                class="container-foot d-flex justify-content-end"
              >
                <ActionButton
                  v-if="!isSubmitted"
                  type="submit"
                  variant="success"
                  class="px-1 actions mb-2"
                  i="fa fa-file-plus pl-2"
                  @click.native.prevent="handleAdd"
                >
                  Añadir
                </ActionButton>
              </div>

              <div>
                <hr />
                <div
                  class="row col-md-12 col-sm-12 font-weight-normal font-14 color-gray--6 mb-2"
                >
                  Razón(es) Seleccionada(s):
                </div>

                <div
                  v-for="(rejectInfo,
                  rejectInfoIndex) in model.rejectionSelectedReasons"
                  :key="rejectInfoIndex"
                >
                  <div class="row col-md-12 col-sm-12 ml-1 p-3 mb-2 bg-callout">
                    <div class="col-md-4 col-sm-12 border-right-2 pt-2">
                      <span>
                        <b>{{ rejectInfo.name }}</b>
                      </span>
                    </div>
                    <div class="col-md-7 col-sm-12">
                      <span class="font-weight-normal font-14 color-gray--6">
                        Comentario:
                      </span>
                      <br />
                      <span class="regular">{{ rejectInfo.comment }}</span>
                    </div>
                    <div class="col-md-1 col-sm-12 text-right pt-2">
                      <ActionButton
                        v-if="!isSubmitted"
                        variant="drop-item"
                        i="fas fa-times-circle text-red font-25"
                        @click="handleRemove(rejectInfo.id)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </validation-observer>
          </div>
        </div>
        <div class="row d-flex justify-content-start mt-2">
          <div class="d-flex">
            <div class="col-md-12 col-sm-12 p-3 ml-3">
              <ErrorComponent
                v-if="rejectionHasNoReasons"
                message="Es necesario documentar la razón por la que no se aceptó la evaluación seleccionada."
                :is-borderless="true"
                variant="withoutspacing"
              />
            </div>
          </div>
        </div>
      </template>
    </callout>
  </div>
</template>

<script>
import Callout from 'custom-callout';
import { CustomDropDown } from '@/components/common';
import { ValidationProvider } from 'vee-validate';
import CustomRadio from 'custom-radio';
import DiscussionStatus from '@/utils/constants/student/discussionStatus';
import CustomTextArea from '@/components/common/CustomTextArea';
import ActionButton from 'ActionButton';
import ErrorComponent from '@/components/common/Error';
import DISCIPLINE_TYPES from '@/utils/constants/disciplineTypes';
import CustomChipsGroup from 'CustomChipsGroup';
import EvaluationRejectionType from '@/utils/constants/student/evaluationRejectionType';
import generalService from '@/services/pei/general';

export default {
  name: 'EvaluationInformationRow',
  components: {
    Callout,
    CustomDropDown,
    ValidationProvider,
    CustomRadio,
    CustomTextArea,
    ActionButton,
    ErrorComponent,
    CustomChipsGroup,
  },
  data() {
    return {
      preSelectedRejectionReasons: [],
      model: {
        discussionStatus: null,
        isImpedimentEvaluationFlag: null,
        rejectionReason: null,
        rejectionSelectedReasons: [],
        rejectionComment: '',
        isValid: null,
      },
      yesNoOptions: [
        {
          value: true,
          label: 'SI',
          check: false,
        },
        {
          value: false,
          label: 'NO',
          check: false,
        },
      ],
      rejectionPanelShow: false,
    };
  },
  props: {
    itemsEval: {
      type: Object,
      default: () => ({
        disciplineTypeName: '',
        evaluationType: '',
        evaluationDate: null,
        statusName: '',
        status: '',
        reevaluationTime: '',
        reevaluationPeriod: '',
        reevaluationPurpose: '',
        studentEvaluationId: '',
        discussionStatusId: null,
        isImpedimentEvaluationFlag: null,
        isValid: null,
      }),
    },
    discussionStatuses: {
      type: Array,
      default: () => [],
    },
    rejectionReasons: {
      type: Array,
      default: () => [],
    },
    isSubmitted: {
      type: Boolean,
      default: false,
    },
    showError: {
      type: Boolean,
      default: false,
    },
    determinationDisabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    rejectionHasNoReasons() {
      return this.canReject && this.model.rejectionSelectedReasons.length == 0;
    },
    showDownloadDocument() {
      return this.$route.query.documents == 'download';
    },
    computedRejectionReasonsList() {
      let availableReasonIds = [];
      switch (this.model.discussionStatus.id) {
        case DiscussionStatus.Rejected:
          availableReasonIds = [
            EvaluationRejectionType.LosResultadosDeLaEvaluaciónNoMidenLoQueSeNecesitabaParaEvaluar,
            EvaluationRejectionType.LaMadrePadreOEncargadoNoEstanDeAcuerdoConLosResultadosDeLaEvaluacion,
            EvaluationRejectionType.LaEvaluacionNoReflejaLasHabilidadesODificultadesQuePresentaElEstudiante,
          ];
          break;
        case DiscussionStatus.PartialAccepted:
          availableReasonIds = [
            EvaluationRejectionType.RazonDelReferido,
            EvaluationRejectionType.HistorialDelDesarrolloEvolutivo,
            EvaluationRejectionType.ConductaObservadaDuranteLaEvaluacion,
            EvaluationRejectionType.AnalisisDeFortalezasYDebilidades,
            EvaluationRejectionType.ImpresionDiagnostica,
            EvaluationRejectionType.RecomendacionesParaEscuelaYHogar,
            EvaluationRejectionType.AnejoIVPlanDeIntervencion,
          ];
          break;
      }
      const list = this.rejectionReasonsList.filter((x) =>
        availableReasonIds.includes(x.id)
      );
      return list.filter(
        (x) => !this.preSelectedRejectionReasons.map((q) => q.id).includes(x.id)
      );
    },
    DiscussionStatus() {
      return DiscussionStatus;
    },
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
    isDiscussionAccepted() {
      return (
        this.model.discussionStatus != null &&
        (this.model.discussionStatus.id == DiscussionStatus.Accepted ||
          this.model.discussionStatus.id == DiscussionStatus.PartialAccepted)
      );
    },
    rejectionLabel() {
      if (this.model.discussionStatus.id == DiscussionStatus.PartialAccepted) {
        return 'Información de Recomendaciones que no se están Aprobando:';
      } else {
        return 'Información de Evaluación Rechazada:';
      }
    },
    rejectionReasonLabel() {
      if (this.model.discussionStatus.id == DiscussionStatus.PartialAccepted) {
        return 'Favor de seleccionar las áreas que fueron rechazadas por el COMPU:';
      } else {
        return 'Favor seleccionar las razones por la cual rechaza la evaluación:';
      }
    },
    rejectionCommentLabel() {
      if (this.model.discussionStatus.id != DiscussionStatus.Accepted) {
        return 'Breve descripción de la razón del rechazo';
      } else {
        return 'Comentario';
      }
    },
    isOcupacional() {
      return this.itemsEval.disciplineTypeId === DISCIPLINE_TYPES.Ocupacional;
    },
    canReject() {
      return (
        this.showError &&
        [DiscussionStatus.Rejected, DiscussionStatus.PartialAccepted].includes(
          this.model.discussionStatus?.id
        )
      );
    },
    isOpened() {
      return (
        this.rejectionPanelShow ||
        (!this.itemsEval.isValid &&
          [
            DiscussionStatus.Rejected,
            DiscussionStatus.PartialAccepted,
          ].includes(this.model.discussionStatus?.id))
      );
    },
    rejectionReasonsList() {
      const ids = this.itemsEval.rejectionReasons.map((f) => f.id);
      const list = this.rejectionReasons.filter((x) => !ids.includes(x.id));
      return [...new Set(list)];
    },
    isPartialAccepted() {
      return (
        this.model.discussionStatus?.id == DiscussionStatus.PartialAccepted
      );
    },
  },
  methods: {
    async downloadDocument(evaluationId) {
      const documentTypeId = 1;
      await generalService.downloadStudentDocument(
        evaluationId,
        documentTypeId
      );
    },
    onChangeYesNo(item) {
      this.model.isImpedimentEvaluationFlag = item.value;
      this.$emit('on-determine-change', item.value);
    },
    onChangeDiscussionStatus() {
      this.rejectionPanelShow = false;

      this.rejectionPanelShow = [
        DiscussionStatus.Rejected,
        DiscussionStatus.PartialAccepted,
      ].includes(this.model.discussionStatus?.id);

      if (
        this.itemsEval.discussionStatusId != this.model.discussionStatus?.id
      ) {
        this.model.isImpedimentEvaluationFlag = null;
        this.yesNoOptions.forEach((x) => (x.check = false));
        this.$emit(
          'on-determine-change',
          this.model.isImpedimentEvaluationFlag
        );
      }

      this.model.rejectionSelectedReasons = [];
      this.model.rejectionReason = null;
      this.model.rejectionComment = '';

      this.$emit('on-discussion-status-change', this.model.discussionStatus);
    },
    handleCallout() {
      this.rejectionPanelShow = !this.rejectionPanelShow;
      this.itemsEval.isValid = !this.rejectionPanelShow;
    },
    addSelectedRejectedReason() {
      if (!this.model.rejectionReason) return;

      this.preSelectedRejectionReasons = [
        ...this.preSelectedRejectionReasons,
        ...[this.model.rejectionReason],
      ];
      this.model.rejectionReason = null;
      this.$refs.evaluationToRejectForm.reset();
    },
    removeSelectedRejectedReason(item) {
      const filtered = this.preSelectedRejectionReasons.filter(
        (x) => x.id != item.id
      );
      this.preSelectedRejectionReasons = [...filtered];
      this.$emit('add-rejection', item.id);
    },
    async handleAdd() {
      const isValid = await this.$refs.evaluationToRejectForm.validate();

      if (!isValid || !this.preSelectedRejectionReasons.length) return;

      this.preSelectedRejectionReasons.forEach((x) =>
        this.model.rejectionSelectedReasons.push({
          id: x.id,
          name: x.name,
          comment: this.model.rejectionComment,
        })
      );
      this.model.rejectionSelectedReasons = [
        ...new Set(this.model.rejectionSelectedReasons),
      ];
      this.$emit('on-push-comments', this.model.rejectionSelectedReasons);

      this.model.rejectionReason = null;
      this.model.rejectionComment = '';
      this.preSelectedRejectionReasons = [];
    },
    handleRemove(itemId) {
      this.model.rejectionSelectedReasons = this.model.rejectionSelectedReasons.filter(
        (x) => x.id !== itemId
      );

      this.$emit('add-rejection', itemId);
    },
    setDeterminationValue(value) {
      if (value == null) return;

      this.model.isImpedimentEvaluationFlag = value;
      const index = this.yesNoOptions.findIndex((x) => x.value == value);

      const item = this.yesNoOptions[index];
      item.check = true;
      this.yesNoOptions[index] = item;
    },
  },
  watch: {
    'itemsEval.discussionStatusId'() {
      this.preSelectedRejectionReasons = [];
    },
  },
  mounted() {
    //this.isValid = true;
    if (this.itemsEval.discussionStatusId != null) {
      this.model.discussionStatus = {};
      this.model.discussionStatus.id = this.itemsEval.discussionStatusId;
    }

    this.setDeterminationValue(this.itemsEval.isImpedimentEvaluationFlag);

    if (this.itemsEval.rejectionReasons.length > 0) {
      this.isValid = this.itemsEval.isValid;
      this.rejectionPanelShow = true;
      this.model.rejectionSelectedReasons = this.itemsEval.rejectionReasons;
    }
  },
};
</script>

<style>
div.v-select.custom-v-select.vs--single.vs--searchable div {
  max-height: 53px;
}
div.custom-radio-container .custom-radio-button {
  width: 60px !important;
}
</style>
<style scoped lang="scss">
@use "sass:map";
@import '@/assets/scss/variables/_colors.scss';

.alert__container {
  margin-right: 5px;
  color: #b97934;
}

.btn-remove-evluation {
  position: absolute;
  right: 41px;
  top: 14px;
  width: 20px;
  height: 20px;
}
.btn-remove-evluation .btn {
  width: 20px;
  height: 20px;
}
.dropdown-item {
  padding: 0.5rem 1.5rem;
}
.alt {
  background-color: #fafbfa;
}
.pointer {
  cursor: pointer;
}
.re-row {
  height: 80px;
}
.fs-13 {
  font-size: 13px;
}
.re-icon {
  font-size: 21px;
  font-weight: 900;
}
.re-icon.expanded {
  color: #2db782;
}
.separator {
  display: flex;
  align-items: center;
  text-align: center;
  color: #ffffff;
  font: 700 14px/17px Lato;
}
.separator::before,
.separator::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid #b5c3bc;
}
.dropdown-item.active,
.dropdown-item:active {
  background-color: transparent;
}
.border-right-2 {
  border-right: 0px solid rgba(114, 114, 114, 0.22);
}

.border-bottom-2 {
  border-bottom: solid 1px #e2e2e2;
}
.bg-callout {
  background-color: #fafafa !important;
}

.custom-radio__extended ::v-deep {
  margin-left: 10px;
  padding-top: 10px;

  .custom-radio-button {
    background-color: #f2f2f2 !important;
  }

  .custom-radio-button.bg-green {
    background-color: #a3e5b3 !important;
  }
}
.divider {
  border: 1px solid #d9e5df;
  height: 1px;
  width: 100%;
}

hr {
  border: 1px solid #e2e2e2 !important;
}
.vl {
  border-left: 1px solid #e5e5e5;
  height: 0px;
}
.divider-horizontal {
  border: 0.5px solid #e2e2e2 !important;
  position: relative;
  top: 12px;
}

.evaluetions-card {
  background-color: #f7f7f7;

  padding-top: 10px;
  width: 100%;
  height: 100%;
  min-height: 103px;
  border-radius: 8px;
  margin-bottom: 12px;
  margin-left: -4px;
}
.label-centered {
  padding-left: 10px;
}
.icon-align {
  position: relative;
  left: 8px;
  bottom: 11px;
}
.bottom-reductor {
  margin-bottom: -16px;
}
.fix-button-close {
  position: relative;
}

.download-document__container {
  display: flex;
  justify-content: center;
  align-items: center;
}

@media only screen and (min-width: 600px) {
  .pl-0 {
    padding-left: 0px;
    position: relative;
    left: -65px;
  }

  .divider-horizontal {
    display: none;
  }
  .border-right-2 {
    border-right: 1px solid rgba(114, 114, 114, 0.22);
  }
  .evaluetions-card {
    background-color: white;

    padding-top: 10px;
    width: 100%;
    height: 100%;
    border-radius: 8px;
    margin-bottom: 12px;
  }
  .label-centered {
    padding-left: 70px;
    height: 71px;
  }
  .icon-align {
    position: relative;
    left: 60px;
    bottom: 10px;
  }
}

@media only screen and (min-width: 1400px) {
  .fix-button-close {
    position: absolute;

    right: 56px;
  }
}
</style>
